module.exports = __webpack_public_path__ + "img/conference1.5f9f294e.png";